'use strict';

var React = require('react');

var SvgPasskeyMajor = function SvgPasskeyMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.531 12.35c-.334.24-.44.741-.149 1.032a.874.874 0 0 1 0 1.236l-.175.175a1 1 0 0 0 0 1.414l.086.086a1 1 0 0 1 0 1.414l-.94.94a.5.5 0 0 1-.707 0l-1.353-1.354a1 1 0 0 1-.293-.707v-3.923a3.5 3.5 0 1 1 3.531-.312Zm-2.031-4.35a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.556c0 1.963-1.567 3.555-3.5 3.555s-3.5-1.592-3.5-3.555c0-1.964 1.567-3.556 3.5-3.556s3.5 1.592 3.5 3.556Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.625 18c-1.45 0-2.625-1.194-2.625-2.667 0-1.472 1.313-4.444 7-4.444 1.08 0 2.004.107 2.79.291a5.012 5.012 0 0 0 1.71 2.32v4.497a2.591 2.591 0 0 1-.125.003h-8.75Z"
  }));
};

exports.SvgPasskeyMajor = SvgPasskeyMajor;
